import { ArrowLeft } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getSearchQuery } from '@/lib/search-navigation';
import { Button } from './button';

export function SearchBackButton() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const search = getSearchQuery(searchParams);
  const label = search ? `Back to search results for "${search}"` : 'Back';

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="min-w-8 max-w-48 shrink-0 gap-1.5 px-2 sm:max-w-64"
      onClick={() => navigate(-1)}
      aria-label={label}
      title={label}
    >
      <ArrowLeft />
      {search && <span className="truncate">{`"${search}"`}</span>}
    </Button>
  );
}
